// InvestmentOptions.jsx
"use client";

import React from "react";
import { motion } from "framer-motion";

const investmentOptions = [
  {
    title: "Forex & Stocks",
    image: "https://images.pexels.com/photos/6693655/pexels-photo-6693655.jpeg?auto=compress&cs=tinysrgb&w=800",
    iconClass: "ri-stock-line",
  },
  {
    title: "Crypto Trading",
    image: "https://images.pexels.com/photos/8441247/pexels-photo-8441247.jpeg?auto=compress&cs=tinysrgb&w=800",
    iconClass: "ri-currency-line",
  },
  {
    title: "Real Estate",
    image: "https://images.pexels.com/photos/439391/pexels-photo-439391.jpeg?auto=compress&cs=tinysrgb&w=800",
    iconClass: "ri-home-smile-line",
  },
  {
    title: "Loaning",
    image: "https://images.pexels.com/photos/4386370/pexels-photo-4386370.jpeg?auto=compress&cs=tinysrgb&w=800",
    iconClass: "ri-bank-line",
  },
  {
    title: "NFTs",
    image: "nft2.jpg",
    iconClass: "ri-gallery-line",
  },
  {
    title: "Mining",
    image: "mining.jpg",
    iconClass: "ri-database-2-line",
  },
  {
    title: "Metaverse Investing",
    image: "meta.jpg",
    iconClass: "ri-vr-line",
  },
  {
    title: "Wealth Management",
    image: "https://images.pexels.com/photos/4968384/pexels-photo-4968384.jpeg?auto=compress&cs=tinysrgb&w=800",
    iconClass: "ri-wallet-3-line",
  },
  {
    title: "Gold",
    image: "gold3.png",
    iconClass: "ri-bar-chart-2-line",
  },
  {
    title: "Crude Oil",
    image: "oil5.png",
    iconClass: "ri-oil-line",
  },
  {
    title: "Agriculture",
    image: "agric1.png",
    iconClass: "ri-plant-line",
  },
  {
    title: "ETFs",
    image: "https://images.pexels.com/photos/4386397/pexels-photo-4386397.jpeg?auto=compress&cs=tinysrgb&w=800",
    iconClass: "ri-exchange-funds-line",
  },
];

export default function InvestmentOptions() {
  return (
    <section className="bg-[#f3f6fb] py-16 px-6 md:px-12 lg:px-24">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
        <span className="text-green-600">INVEST</span> AND <span className="text-black">TRADE</span>
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {investmentOptions.map((item, index) => (
          <motion.div
            key={index}
            whileHover={{ scale: 1.05 }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.05 }}
            className="relative bg-white rounded-xl overflow-hidden shadow hover:shadow-lg cursor-pointer group"
          >
            <img
              src={item.image}
              alt={item.title}
              className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="p-4">
              <h3 className="text-lg font-semibold text-gray-800">{item.title}</h3>
              <div className="h-1 w-8 bg-blue-500 mt-2" />
            </div>
            <div className="absolute top-2 right-2 bg-white p-2 rounded-lg text-blue-700 text-xl shadow-md">
              <i className={`ri ${item.iconClass} text-xl`}></i>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
